<template>
  <vx-card class="mt-base">
    <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
    <p class="mb-5">
      Framing refers to how we choose to think about things. With each event in our lives, we have
      the option to view it in a positive light or a negative light. You may have heard the
      question, “Is the glass half empty or is it half full?”
    </p>
    <p class="mb-5">
      The glass has the same amount of water in it regardless of how we answer, but one of the
      answers chooses to ‘frame’ things positively, while the other frames things negatively. We
      usually call the ‘glass half full’ type person an optimist and the ‘half empty’ person a
      pessimist.
    </p>
    <p class="mb-5">
      In the video below, psychologist Dr. Alia Crum explores the power of mindset and how we frame
      the things in our lives that can affect our health and performance.
    </p>

    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-1/2 w-full my-5">
        <custom-video
          aria-label="Watch becoming becoming registered video"
          elem-id="video-btn-0"
          :video-image="videoTrigger1"
          :video-url="videos[1]"
        />
      </div>
    </div>

    <p class="mb-5">
      Once you’ve finished watching the video, can you write down 3 things from Dr. Crum’s talk that
      you learned or found interesting?
    </p>
    <p class="mb-5">
      A few keywords and phrases have been written below to help spark your memory!
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <img
          src="@/assets/images/experiences/psychology/activity31.png"
          alt="Seven key words: Mindset, Placebo Effect, Healing Properties, Milkshakes, Stress, Yale, Mindsets Matter."
          class="mx-auto img-responsive"
        />
      </div>
    </div>
    <div v-for="index in 3" :key="index" class="overflow-hidden">
      <label v-if="isEditable">
        {{ index }}:
        <text-block v-model="data['question' + index]" :editable="isEditable" />
      </label>
      <p v-else class="float-left py-5 pr-2">{{ index }}:</p>
    </div>

    <p class="mb-5">
      One great way to help us reframe things in a positive light is to practise gratitude. This
      involves thinking of things in our lives that we are grateful for. This demands a conscious
      effort to look for the positive things in life, even when they’re hard to find initially.
    </p>
    <p class="mb-5">
      Often, when we can’t think of something to be grateful for, it just means we need to think
      about things differently.
    </p>
    <p class="mb-5">
      For example, if your friend betrayed you, rather than see it as a negative thing, look for the
      positive. By your friend betraying you, you’ve discovered they’re not the person you thought
      they were. You now know you can’t rely on them or trust them and this information will save
      you a lot of time and heartache in the future.
    </p>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import CustomVideo from '@/components/CustomVideo';

export default {
  components: {
    CustomVideo,
  },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/psychology/positive_refaming_trigger.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/0tqq66zwa7g?autoplay=1',
      },
      login_type: localStorage.getItem('login_type'),
      showVideoPopupYt: false,
      ytVideoUrl: false,
      answers: {
        question1: null,
        question2: null,
        question3: null,
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}

.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}

.scale-header {
  background: #f5f5f5;
  padding-top: 5px;
  font-weight: 600;
}
</style>
